import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

// No changes to Nav, NavLogo, LogoImage, NavLink, or CTAButton from your original code
const Nav = styled.nav`
    background: #fff;
    padding: 1rem 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    position: sticky;
    top: 0;
    z-index: 100;
`;

const NavLogo = styled(Link)`
    text-decoration: none;
`;

const LogoImage = styled.img`
    height: 60px;
    width: auto;
    display: block;
`;

const NavLink = styled(Link)`
    color: #555;
    text-decoration: none;
    font-weight: 600;
    padding: 0.5rem 0; /* Added for better spacing in mobile view */
    &:hover {
        color: #2a7de1;
    }
`;

const CTAButton = styled(Link)`
    background-color: #f5a623;
    color: #fff;
    padding: 0.5rem 1.5rem;
    border-radius: 20px;
    text-decoration: none;
    font-weight: 600;
    transition: background-color 0.3s;
    &:hover {
        background-color: #d88e1a;
    }
`;

// --- MODIFICATIONS START HERE ---

// The Hamburger Icon
const MenuIcon = styled.div`
  display: none; // Hidden on desktop
  flex-direction: column;
  cursor: pointer;

  div {
    width: 25px;
    height: 3px;
    background-color: #555;
    margin: 4px 0;
    transition: 0.4s;
  }

  @media screen and (max-width: 768px) {
    display: flex; // Visible on mobile
  }
`;

// The NavLinks container now accepts an `isOpen` prop for conditional styling
const NavLinks = styled.div`
    display: flex;
    gap: 1.5rem;
    align-items: center;

    @media screen and (max-width: 768px) {
        // On mobile, it becomes a vertical column that slides in from the top
        flex-direction: column;
        gap: 1rem;
        position: absolute;
        top: 85px; // Position it right below the navbar
        left: 0;
        width: 100%;
        background-color: #fff;

        // Use max-height for a smooth slide-down transition
        max-height: ${({ isOpen }) => (isOpen ? '400px' : '0')};
        overflow: hidden;
        transition: max-height 0.3s ease-in-out;

        padding: ${({ isOpen }) => (isOpen ? '1rem 0' : '0')};
        border-bottom: ${({ isOpen }) => (isOpen ? '1px solid #eee' : 'none')};
    }
`;


const Navbar = () => {
    // State to manage the open/closed status of the mobile menu
    const [isOpen, setIsOpen] = useState(false);

    // Function to close the menu, useful for link clicks
    const closeMenu = () => setIsOpen(false);

    return (
        <Nav>
            <NavLogo to="/" onClick={closeMenu}>
                <LogoImage src={logo} alt="BeFriend ABA Services for Children" />
            </NavLogo>

            {/* The Hamburger Icon, which toggles the 'isOpen' state */}
            <MenuIcon onClick={() => setIsOpen(!isOpen)}>
                <div />
                <div />
                <div />
            </MenuIcon>

            {/* Pass the 'isOpen' state to the NavLinks styled-component */}
            <NavLinks isOpen={isOpen}>
                <NavLink to="/" onClick={closeMenu}>Home</NavLink>
                <NavLink to="/about" onClick={closeMenu}>About</NavLink>
                <NavLink to="/services" onClick={closeMenu}>Services</NavLink>
                <NavLink to="/locations" onClick={closeMenu}>Locations</NavLink>
                <NavLink to="/contact" onClick={closeMenu}>Contact</NavLink>
                <CTAButton to="/contact" onClick={closeMenu}>Enroll Now</CTAButton>
            </NavLinks>
        </Nav>
    );
};

export default Navbar;